<form [formGroup]="mfaRecoveryForm" class="relative overflow-visible">
  <div
    class="form-input py-1 mb-8"
    [ngClass]="{
      'has-error':
        mfaRecoveryForm.controls['recovery_code'].errors && mfaRecoveryForm.controls['recovery_code'].touched,
    }"
  >
    @if (!(mfaRecoveryForm.controls['recovery_code'].errors && mfaRecoveryForm.controls['recovery_code'].touched)) {
      <label>Recovery Code</label>
    } @else {
      <label>
        <ion-icon name="alert-circle" class="text-base"></ion-icon>
        @if (mfaRecoveryForm.controls['recovery_code']?.errors?.['required']) {
          <span>Recovery code is required</span>
        }
      </label>
    }
    <input
      type="text"
      formControlName="recovery_code"
      (focus)="mfaRecoveryForm.controls['recovery_code'].markAsUntouched()"
      autofocus
    />
  </div>
</form>
<div class="mt-2 flex flex-col items-center justify-between gap-3">
  <button (click)="recoveryCodeLogin()" class="my-0 px-6 w-full">Proceed</button>
  <a routerLink="/" class="btn-link text-primary text-base font-medium p-2">Back to login</a>
</div>
